import { render, staticRenderFns } from "./CompanyPaymentMethod.vue?vue&type=template&id=8d238eae"
import script from "./CompanyPaymentMethod.vue?vue&type=script&lang=js"
export * from "./CompanyPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./CompanyPaymentMethod.vue?vue&type=style&index=0&id=8d238eae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports